import React, { useEffect } from 'react'
import { useDirectusApi } from '../../../libs/data-access'
import { EBadge, EModal, ETable } from '../../../libs/ui'
import moment from 'moment'
import { Table } from '@mantine/core'
import { FaBell } from 'react-icons/fa'
import { useNavigate } from 'react-router-dom'
import { humanize } from '../../../utils/utility'
import { BsX } from 'react-icons/bs'

const INCLUSION_OPTIONS = [
    { label: 'Tele Follow-up', value: 'tele' },
    { label: 'Physical Follow-up', value: 'physical' },
];

export default function EPendingVisitList() {

    const { fetchDirectData } = useDirectusApi();
    const navigate = useNavigate();

    const [isOpenModal, setIsOpenModal] = React.useState<boolean>(false)
    const [activeFilter, setActiveFilter] = React.useState<string | undefined>(undefined)
    const [pendingVisitList, setPendingVisitList] = React.useState<{
        age: string
        alternate_contact_no: string
        disease_case: Array<string>
        gender: string
        primary_contact_no: string
        center_name: string
        center_user_id: string
        latest_record_created: string
        visit_date: string
        user_id: string
        address: string
        first_name: string
        last_name: string
        tele_followup: boolean
    }[]>([]);


    const fetchPendingVisitList = async () => {
        try {
            let url = `custom/pending-visits?visit_date=${moment().add(1, 'day').format("YYYY-MM-DD")}`;
            if (activeFilter) {
                url += `&type_of_followup=${activeFilter}`;
            }
            const response = await fetchDirectData(url);
            const data = await response.data
            setPendingVisitList(data)
        } catch (error) {
            console.error("Error fetching pending visits:", error)
        }
    }

    useEffect(() => {
        fetchPendingVisitList()
    }, [activeFilter])


    return (
        <>
            <div
                onClick={() => setIsOpenModal(true)}
                className="group cursor-pointer flex items-center gap-3 bg-white border border-gray-100 border-l-4 border-l-emerald-500 rounded-lg px-4 py-3 shadow-sm hover:shadow-md transition-all duration-150"
            >
                {/* Icon */}
                <div className="flex-shrink-0 w-8 h-8 rounded-full bg-emerald-100 flex items-center justify-center">
                    <FaBell className="text-emerald-600 text-sm" />
                </div>

                {/* Message */}
                <div className="flex-1 min-w-0">
                    <p className="text-[13px] text-gray-500 leading-snug">
                        <span className="inline-flex items-center justify-center w-9 h-5 rounded-full bg-emerald-500 text-white text-[11px] font-bold mr-1.5 align-middle">
                            {pendingVisitList?.length || 0}
                        </span>
                        patients have <span className="font-semibold text-gray-700">pending follow-ups</span> and need attention today.
                    </p>
                </div>

                {/* CTA */}
                <span className="flex-shrink-0 text-xs font-medium text-emerald-600 group-hover:text-emerald-700 whitespace-nowrap">
                    View details →
                </span>
            </div>
            <EModal
                title="Pending follow up list"
                isOpen={isOpenModal}
                size="90%"
                setIsOpen={() => { setIsOpenModal(false) }}
            >
                <div className="overflow-y-auto max-h-[calc(100vh-200px)] p-1">
                    <div className="flex justify-end gap-2 mb-3 pr-2">
                        {INCLUSION_OPTIONS.map((opt) => (
                            <EBadge
                                key={opt.value}
                                label={opt.label}
                                isActive={activeFilter === opt.value}
                                onClick={() => setActiveFilter(activeFilter === opt.value ? undefined : opt.value)}
                                variant={'blue'}
                            />
                        ))}
                        {
                            activeFilter && (
                                <button
                                    type="button"
                                    onClick={() => {
                                        setActiveFilter(undefined)
                                    }}
                                    className="flex items-center gap-0.5 text-xs text-gray-400 hover:text-blue-500 font-medium transition-colors cursor-pointer whitespace-nowrap ml-1"
                                >
                                    <BsX size={14} /> Clear
                                </button>
                            )
                        }
                    </div>

                    <ETable>
                        <Table.Thead>
                            <Table.Tr>
                                <Table.Th>Patient Name</Table.Th>
                                <Table.Th>Mobile Number</Table.Th>
                                <Table.Th>Alternate Mobile Number</Table.Th>
                                <Table.Th>Address</Table.Th>
                                <Table.Th>Disease Case</Table.Th>
                                <Table.Th>Latest Visit Date</Table.Th>
                                <Table.Th className='text-end'>Upcoming Visit Mode</Table.Th>

                                {/* <Table.Th className='text-end'>Center Name</Table.Th> */}
                            </Table.Tr>
                        </Table.Thead>
                        <Table.Tbody>
                            {pendingVisitList?.map((item) => (
                                <Table.Tr key={item.user_id}
                                    onClick={() => {
                                        navigate(`/index/patient/details?patient_id=${item?.user_id}`)
                                    }}
                                    className="cursor-pointer"
                                >
                                    <Table.Td>{`${item.first_name} ${item.last_name} (${item.age}, ${item.gender})`}</Table.Td>
                                    <Table.Td>{item.primary_contact_no}</Table.Td>
                                    <Table.Td>{item.alternate_contact_no}</Table.Td>
                                    <Table.Td>{item.address}</Table.Td>
                                    <Table.Td>{humanize(item.disease_case?.join(", "))}</Table.Td>
                                    <Table.Td>{moment(item.visit_date).format("DD-MM-YYYY")}</Table.Td>
                                    <Table.Td>
                                        {item?.tele_followup != true
                                            ? "Tele Follow-up"
                                            :
                                            "Physical Follow-up"
                                        }
                                    </Table.Td>
                                </Table.Tr>
                            ))}
                        </Table.Tbody>
                    </ETable>
                </div>
            </EModal>
        </>
    )
}
